import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);

// EPELAY_DYNAMIC_HOME_FALLBACK_START
(function () {
  function isHomePage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function currentHomeSection() {
    var existingGrowth = document.querySelector('[data-epelay-growth-home]');
    if (existingGrowth) return null;
    var oldHome = document.querySelector('.epelay-home');
    if (oldHome) return oldHome.closest('.shopify-section') || oldHome;
    return document.querySelector('main .shopify-section[id*="__main"]');
  }

  function replaceHomeSection() {
    if (!isHomePage()) return;
    var target = currentHomeSection();
    if (!target) return;

    fetch('/?section_id=epelay-home&epelay_dynamic_home=' + Date.now(), {
      credentials: 'same-origin',
      headers: { accept: 'text/html' },
    })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updated = doc.querySelector('#shopify-section-epelay-home');
        if (!updated || !updated.querySelector('[data-epelay-growth-home]')) return;
        target.replaceWith(updated);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceHomeSection, { once: true });
  } else {
    replaceHomeSection();
  }
})();
// EPELAY_DYNAMIC_HOME_FALLBACK_END
